<template>

  <div class="stock-detail-page">
    <menubar active="stock"></menubar>
    <div v-if="loading" class="loading-box">
      LOADING...
      <loading-bar></loading-bar>
    </div>

    <v-touch class="touch-root"
      @panmove="pageMove"
      @panend="pageMoveEnd"
      :swipe-options="{ direction: 'vertical', threshold: 10 }"
    >
      <div class="back-msg" :style="{opacity: backMsgOpacity}">BACK TO LIST...</div>

      <transition name="pop" class="errmsg-box">
        <div class="errmsg" v-if="hasErr && errmsg" :style="{
            [swipeY ? 'transform' : '_dummy']: `translateY(${swipeY}px)`
          }"
        >
          <div class="msg">
            {{ errmsg }}
          </div>
          <div class="err-unstock" v-if="stock" @click="unstockErrStock">× Unstock this item</div>
          <div class="note">
            ⬇︎ Swipe down to back to the list.
          </div>
        </div>
      </transition>

      <transition name="pop">
        <tweet-detail class="detail-page"
          v-show="isVisible && !hasErr"
          :imgsrc="imgsrc"
          :altsrc="altsrc"
          :tweet="tweet"
          :mindex="mindex"
          :stock="stock"
          @stocked="onstock"
          @unstocked="onunstock"
          :style="{
            [swipeY ? 'transform' : '_dummy']: `translateY(${swipeY}px)`
          }"
        ></tweet-detail>
      </transition>
    </v-touch>
  </div>

</template>

<style scoped>
.touch-root {
  width: 100%;
  height: 100%;
}
.stock-detail-page {
  height: 100%;
  padding-top: 40px;
}
.back-msg {
  position: absolute;
  top: 50px;
  width: 100%;
  color: #666;
}
.loading-box{
  color: gray;
  width: 100%;
  padding-top: 100px;
  text-align: center;
  font-size: 13pt;
}
.errmsg {
  padding-top: 100px;
  text-align: center;
}
.errmsg .msg {
  font-size: 13pt;
}
.errmsg .note {
  font-size: 10pt;
}
.err-unstock {
  margin: 15px;
  font-size: 10pt;
  text-decoration: underline;
}
/* animation */
.pop-enter-active, .pop-leave-active{
  transition: transform 300ms cubic-bezier(.1,.7,.71,1.17);
}
.pop-enter, .pop-leave{
  transform: scale(0.65);
}
</style>

<script>
import StockApi from '@/api/StockApi'
import TwApi from '@/api/TwApi'
import Menubar from '@/components/Menubar'
import TweetDetail from '@/components/TweetDetail'
import LoadingBar from '@/components/LoadingBar'

const SWIPE_BORDER = 50
const ERRMSGS = {
  NOT_STOCKED: 'This item is not exists in your stock list.',
  TWEET_UNABILABLE: 'Can not get the original tweet. It may be deleted :('
}

export default {
  name: 'StockDetailPage',
  components: {TweetDetail, Menubar, LoadingBar},
  data () {
    return {
      imgsrc: null,
      altsrc: null,
      tweet: null,
      isVisible: false,
      mindex: -1,
      stock: null,
      hasErr: false,
      swipeY: 0,
      loading: true,
      errmsg: null
    }
  },
  computed: {
    backMsgOpacity () { return Math.min(1, Math.abs(this.swipeY) / SWIPE_BORDER) }
  },
  methods: {
    /** TweetDetailでアイテムがStockされた時のイベントハンドラ */
    onstock (stock) {
      this.stock = stock
      this.$router.push(`/stock/${stock.sid}`)
    },
    /** TweetDetailでアイテムがStock解除された時のイベントハンドラ */
    onunstock (stock) {
      this.stock = null
      this.$router.push(`/status/${stock.statusid}/${stock.mindex}`)
    },
    /** エラー時にこの画面内のUnstockボタンが押された時の処理。解除して一覧にな戻る */
    unstockErrStock () {
      if (!this.stock) { return }
      StockApi.removeFromStocks(this.stock.sid).then(() => {
        this.$router.push('/stocks')
      })
    },
    pageMove (ev) {
      this.$data.swipeY = ev.deltaY
    },
    pageMoveEnd (ev) {
      this.$data.swipeY = 0
      const shouldMove = Math.abs(ev.deltaY) >= SWIPE_BORDER
      if (shouldMove) {
        this.$router.push('/stocks')
      }
    }
  },
  mounted () {
    const {stockid} = this.$route.params
    if (!stockid) { return }
    StockApi.getStock(stockid).then(stock => {
      if (!stock) {
        this.hasErr = true
        this.errmsg = ERRMSGS.NOT_STOCKED
        this.loading = false
        return
      }
      TwApi.status(stock.statusid).then((tweet) => {
        if (!tweet || !tweet.id_str) {
          // invalid resp (e.g. deleted tweet)
          this.hasErr = true
          this.errmsg = ERRMSGS.TWEET_UNABILABLE
          this.loading = false
          this.stock = stock
          return
        }
        const mindex = stock.mindex
        const medias = tweet['extended_entities'].media
        const media = medias[mindex]
        const src = media['media_url_https']
        this.$data.imgsrc = src
        this.$data.altsrc = `${src}:thumb`
        this.$data.tweet = tweet
        this.$data.mindex = mindex * 1 || 0
        this.stock = stock
        this.$data.isVisible = true
        this.loading = false
      })
    })
  },
  beforeDestroy () {
    this.$data.isVisible = false
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/StockDetailPage.vue